/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { tokens } from "../../../theme";
import { Box, Typography, useTheme } from "@mui/material";
import { DataGridPro, GridActionsCellItem } from "@mui/x-data-grid-pro";
import { tabbedDataGridPage } from "../../../styles/commonPageStyles";
import { useListAllDbSoftware } from "../../../api/softwareImages";
import { useSubmitDbPatchRequestDialog } from "../Dialogs/SubmitDbPatchRequestDialog";
import { useNavigate } from "react-router-dom";
import { CloudIcon } from "../Utils";

const DbSoftware = ({
  engine,
  releaseBranch,
  displayNotification,
  reloadToggle,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();

  const [dbSoftware, setDbSoftware] = useState([]);

  const { submitDbPatchRequestDialog, setOpenSubmitDbPatchRequestDialog } =
    useSubmitDbPatchRequestDialog(
      () => navigate(`/apps/tessell/software-images/db-software/builds`),
      displayNotification
    );

  const {
    postData: listAllDbSoftware,
    response: listAllDbSoftwareResp,
    isLoading: isLoadingDbSoftware,
  } = useListAllDbSoftware(engine, releaseBranch);

  useEffect(() => {
    listAllDbSoftware();
  }, [engine, releaseBranch, reloadToggle]);

  useEffect(() => {
    if (Array.isArray(listAllDbSoftwareResp?.dbSoftware)) {
      setDbSoftware(listAllDbSoftwareResp.dbSoftware);
    } else {
      setDbSoftware([]);
    }
  }, [listAllDbSoftwareResp]);

  const columns = [
    {
      field: "patchVersionName",
      renderHeader: () => <Typography variant="h5">Name</Typography>,
      flex: 2,
      cellClassName: "name-column--cell",
      renderCell: ({ row: { patchVersionName } }) => (
        <Typography variant="h5">{patchVersionName || ""}</Typography>
      ),
    },
    {
      field: "patchVersion",
      flex: 2,
      renderHeader: () => <Typography variant="h5">Patch Verison</Typography>,
      renderCell: ({ row: { patchVersion } }) => (
        <Typography variant="h5">{patchVersion ?? ""}</Typography>
      ),
    },
    {
      field: "majorVersion",
      flex: 2,
      renderHeader: () => <Typography variant="h5">Major Version</Typography>,
      renderCell: ({ row: { majorVersion } }) => (
        <Typography variant="h5">{majorVersion ?? ""}</Typography>
      ),
    },
    {
      field: "osVersionName",
      flex: 2,
      renderHeader: () => <Typography variant="h5">OS</Typography>,
      renderCell: ({ row: { osVersionName } }) => (
        <Typography variant="h5">{osVersionName ?? ""}</Typography>
      ),
    },
    {
      field: "clouds",
      flex: 2,
      renderHeader: () => <Typography variant="h5">Clouds</Typography>,
      renderCell: ({ row: { clouds } }) => (
        <>
          {Object.keys(clouds)?.map((item, i) => (
            <CloudIcon key={i} cloud={item} />
          ))}
        </>
      ),
    },
    {
      field: "actions",
      type: "actions",
      flex: 0.5,
      getActions: ({ row }) => [
        <GridActionsCellItem
          label="Submit Patch Request"
          onClick={() => {
            setOpenSubmitDbPatchRequestDialog(
              {
                engine: engine,
                releaseBranch: releaseBranch,
                majorVersion: row?.majorVersion,
                majorVersionName: row?.majorVersionName,
                oldPatchVersionName: row?.patchVersionName,
                oldPatchVersion: row?.patchVersion,
              },
              Object.keys(row?.clouds)
            );
          }}
          showInMenu
        />,
      ],
    },
  ];

  return (
    <Box sx={tabbedDataGridPage.dataGridBoxStyles(colors)}>
      {submitDbPatchRequestDialog}
      <DataGridPro
        disableSelectionOnClick
        getRowId={(row) => row?.versionRefId}
        loading={isLoadingDbSoftware}
        rows={dbSoftware}
        columns={columns}
      />
    </Box>
  );
};

export default DbSoftware;
